import { addSeconds } from 'date-fns';
import { REFRESH_ACCESS_TOKEN_TIMER_COOKIE_KEY } from '../constants';
import { ROLES } from '../types';
import { setCookie } from './cookieUtils';

export function getOffset(page: number, limit: number): number {
  return (page - 1) * limit;
}
export function sleep(delay: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, delay);
  });
}

export function customScrollIntoView(el: Element) {
  sleep(15).then(() => {
    // Element is outside the view from the bottom
    if (el.getBoundingClientRect().bottom > window.innerHeight) {
      //  The bottom of the Element will be aligned to the bottom of the visible area of the scrollable ancestor.
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      });
    }
    // Element is outside the view from the top
    if (el.getBoundingClientRect().top < 0) {
      // The top of the Element will be aligned to the top of the visible area of the scrollable ancestor
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  });
}

export function mapRole(role: ROLES) {
  switch (role) {
    case 'business_operator':
      return 'Business Operator';
    case 'channel_operator':
      return 'Channel Operator';
    case 'content_manager':
      return 'Content Manager';
    case 'customer_admin':
      return 'Admin';
    case 'monitor':
      return 'Monitor';
    case 'scheduler':
      return 'Scheduler';
    case 'amagi_operator_admin':
      return 'Admin';
    case 'amagi_sales_admin':
      return 'Admin';
    case 'amagi_platform_admin':
      return 'Admin';
    default:
      return '';
  }
}

export function setRefreshTokenTimerCookie(
  actualExpiryTime: number,
  modifiedExpiryTime: number,
) {
  setCookie({
    cookieKey: REFRESH_ACCESS_TOKEN_TIMER_COOKIE_KEY,
    cookieData: JSON.stringify({
      actualExpiryTime,
      modifiedExpiryTime,
    }),
    expires: addSeconds(new Date(), modifiedExpiryTime),
    path: '/',
  });
}

const landingPaths = ['/', '/setup', '/reset-password', '/signup', '/signin'];

export function shouldNavigateToSignInPage() {
  const pathName = window.location.pathname;
  if (landingPaths.includes(pathName) || pathName.includes('/signup')) {
    return false;
  }
  return true;
}
